import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "../../ts/GlobalSetting";
import {gsap} from "gsap";
import { getViewportName } from "@ts/sframe/ViewportRoot";

export default class MarketingNav extends ComponentBase
{
  private isStuck: boolean;

  constructor(elem: ComponentElem)
  {
    super(elem);
    

    let $buttons = this.$root.find(".link");
    $buttons.on("click", (event: Event) =>
    {
      event.preventDefault();

      let elem: HTMLElement = event.target as HTMLElement,
        target = elem.getAttribute("href"),
        isCollapseAbleContent = elem.getAttribute("is-collapse-able-content") === "true";


      this.to(target, isCollapseAbleContent);
    });

    let buttonList = $buttons.toArray();
    buttonList.forEach((elem)=>
    {
      let href = elem.getAttribute("href");
      if(href)
      {
        let $target = $(href);
        if($target.length === 0) $(elem).detach();
      }
      
    });

    window.addEventListener("scroll", () =>
    {
      this._updateScrollTop();
    });

    this._updateScrollTop();
  }

  to(hash: string, isCollapseAbleContent: boolean = false)
  {
    // console.log("to " + hash);

    // this.emiiter.emit("triggered", isCollapseAbleContent);    

    // console.log(isCollapseAbleContent);
    
    
    let navHeight = GS.getNavHeight(),
      myNavHeight = this.isStuck ? 45 : 70,

      offsetY = navHeight + myNavHeight - 1;

    gsap.to(window, { duration: .5, scrollTo: { y: hash, offsetY: offsetY } });
  }

  _updateScrollTop()
  {
    let navHeight = GS.getNavHeight();

    let bound = this.$root[0].getBoundingClientRect();

    this.isStuck = bound.top <= navHeight;
    
    this.$root.attr("is-stuck", this.isStuck ? "true" : "false");
  }
}